export default "/credits/business/assets/f8e00d7fa7cae316b1dcca7b1e181356.png";